import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    dialog: false,
    loading: false,
    claimsRemovalRequest: [],
    active: [],
    order_column: 'license',
    order_type: 'asc',
    page: 1,
    page_size: 10,
    filter: {},
    labels: [],
    selectAll: false,
    selectedRows: [],
    status: 'Active'
  },

  mutations: {
    setClaimsRemovalRequest(state, payload) {
      state.claimsRemovalRequest = payload
    },
    setSelectAll(state, payload) {
      state.selectAll = payload;
    },
    setSelectedRows(state, payload) {
      state.selectedRows = payload;
    },
    setActive(state, payload) {
      state.active = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setDialog(state, payload) {
      state.dialog = payload
    },
    setFilter(state, payload) {
      state.filter = payload
    },
    setLabels(state, payload) {
      state.labels = payload
    },
      setStatus(state, payload) {
          state.status = payload
      },
  },

  actions: {
    readLabels({ commit }) {
      axios.admin
          .get('cms/youtube/claims/labels')
          .then(r => {
            commit('setLabels', r.data.data)
            commit('setLoading', false)
          })
          .catch(() => {
            commit('setLoading', false)
          })
    },
    readRequestedClaims({ commit, state }, { claim_type, status }) {
      commit('setLoading', true)
      commit('setClaimsRemovalRequest', [])
        axios.admin
          .get('cms/youtube/claims', {
            params: {
              page: state.page,
              page_size: state.page_size,
              order_column: state.order_column,
              order_type: state.order_type,
              claim_type: claim_type,
              requested_by_user: 1,
              status: state.status,
              ...state.filter
            }
          })
          .then(r => {
            //if (claim_type === 'Public') {
              commit('setClaimsRemovalRequest', r.data.data)
            //}
            commit('setLoading', false)
          })
          .catch(() => {
            commit('setLoading', false)
          })
    },
    releaseClaim({ commit, dispatch, state }, claimId) {
      commit('setLoading', true)
      commit('setClaimsRemovalRequest', [])
      axios.admin
          .put('cms/youtube/claims/release/' + claimId)
          .then(() => {
            dispatch('readRequestedClaims', {
              claim_type: 'Public',
              status: state.filter.status
            })
          })
          .catch(() => {
            commit('setLoading', false)
          })
    },
    releaseAllClaims({ commit, dispatch, state }) {
      commit('setLoading', true)
      commit('setClaimsRemovalRequest', r.data.data)
      axios.admin
          .put('cms/youtube/claims/releaseAll', {
            ...state.filter
          })
          .then(() => {
            dispatch('readRequestedClaims', {
              claim_type: 'Public',
              status: state.filter.status
            })
          })
          .catch(() => {
            commit('setLoading', false)
          })
    },
    releaseSelectedClaims({ commit, dispatch, state }) {
      commit('setLoading', true)
      axios.admin
          .put('cms/youtube/claims/releaseSelected', {
            ...state.filter,
            requested_ids: state.selectedRows
          })
          .then(() => {
            dispatch('readRequestedClaims', {
              claim_type: 'Public',
              status: state.status
            })
          })
          .catch(() => {
            commit('setLoading', false)
          })
    },
    confirmClaim({ commit, dispatch, state }, claimId) {
      commit('setLoading', true)
      axios.admin
          .put('cms/youtube/claims/confirm/' + claimId)
          .then(() => {
            dispatch('readRequestedClaims', {
              claim_type: 'Public',
                status: state.status
            })
          })
          .catch(() => {
            commit('setLoading', false)
          })
    },
    rejectClaim({ commit, dispatch, state }, claimId) {
      commit('setLoading', true)
      axios.admin
          .put('cms/youtube/claims/reject/' + claimId)
          .then(() => {
            dispatch('readRequestedClaims', {
              claim_type: 'Public',
                status: state.status
            })
          })
          .catch(() => {
            commit('setLoading', false)
          })
    },
    confirmAllClaims({ commit, dispatch, state }) {
      commit('setLoading', true)
      axios.admin
          .put('cms/youtube/claims/confirmAll', {
            ...state.filter
          })
          .then(() => {
            dispatch('readClaims', 'Public')
            dispatch('readClaims', 'Private')
          })
          .catch(() => {
            commit('setLoading', false)
          })
    },
    generateReport({ commit, state }) {
      commit('setLoading', true)
      axios.admin
          .get('cms/youtube/claims/report', {
            params: {
              ...state.filter
            }
          })
          .then(r => {
            const url = window.URL.createObjectURL(new Blob([r.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'report_youtube_contentid_claims.csv')
            document.body.appendChild(link)
            link.click()
            commit('setLoading', false)
          })
          .catch(() => {
            commit('setLoading', false)
          })
    }
  }
}